import script from "./toggle-switch.vue?vue&type=script&setup=true&lang=js"
export * from "./toggle-switch.vue?vue&type=script&setup=true&lang=js"

import "./toggle-switch.vue?vue&type=style&index=0&id=7067f949&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7067f949"]])

export default __exports__